import Vue from 'vue'
import { lxMC, lxMV } from '@zhenguo/jssdk/lx'
import installDirective from '../vue-directive/lx'

export default {
  install(app: typeof Vue) {
    app.prototype.$lxMC = lxMC
    app.prototype.$lxMV = lxMV
    installDirective(app)
  },
}
